import type { zhHK } from '../zh-HK';

/**
 * zh-CN —— 简体中文（**必須同 zh-HK 逐 key 對齊**；型別由 `typeof zhHK` 檢查）
 */
export const zhCN: typeof zhHK = {


  language_label: '语言',
  locale_zh_hk: '繁體中文（香港）',
  locale_en: 'English',
  locale_zh_cn: '简体中文',

  back_home: '返回首页',

  login_email: 'Email',
  login_password: '密码',
  login_submit: '登录',
  login_working: '登录中…',
  login_failed: '登录失败，请再试。',
  login_phone_ph: '请输入手机号码',

  setpw_title: '设置密码',
  setpw_new: '新密码（至少 8 个字符）',
  setpw_confirm: '确认密码',
  setpw_submit: '设置并登录',
  setpw_working: '设置中…',
  setpw_mismatch: '两次密码不一致',
  setpw_nolink: '邀请链接不完整（没有 token）—— 请使用管理员发出的完整链接。',
  setpw_failed: '设置失败，请再试。',

  member_title: '会员区',
  member_greeting: '你好，{{email}}',
  member_role: '角色：{{role}}',
  member_todo: '会员功能（会籍／活动／文件／通知）会在 M3 之后逐块加上。',
  logout: '登出',

  'tab.aria': '底部导航',
  'tab.benefits': '优惠',
  'tab.news': '资讯',
  'tab.cards': '我的卡',
  'tab.ads': '广告',
  'tab.settings': '设置',
  page_todo: '这部分会在 M3 之后实现（现在还没做）。',

  admin_title: '管理台',
  admin_members: '会员管理',
  admin_benefits: '优惠管理',
  admin_news: '资讯管理',
  admin_back: '返回会员区',
  btn_new: '新增',
  btn_edit: '编辑',
  btn_delete: '删除',
  btn_save: '保存',
  btn_cancel: '取消',
  confirm_delete: '确定删除？',
  empty_none: '暂时没有数据',
  col_no: '会员编号',
  col_name: '姓名',
  col_type: '种类',
  col_status: '状态',
  col_email: 'Email',
  col_phone: '电话',
  col_company: '公司',
  col_title: '标题',
  col_partner: '合作伙伴',
  col_published: '状态',
  f_title: '标题',
  f_body: '内容',
  f_partner: '合作伙伴',
  f_valid_from: '生效日',
  f_valid_to: '到期日',
  f_name: '姓名',
  f_type: '会籍种类',
  f_company: '公司',
  f_email: 'Email',
  f_phone: '电话',
  f_status: '状态',
  f_notes: '备注',
  f_photo: '会员相片',
  f_photo_remove: '移除相片',
  photo_title: '我的相片',
  photo_uploading: '上传中…',
  photo_saved: '相片已更新',
  photo_err_big: '相片太大，请选另一张',
  photo_err_config: '相片服务未设置，请联络管理员',
  photo_err_generic: '上传失败，请再试',
  f_published: '已发布',
  status_active: '生效',
  status_pending: '待批',
  status_expired: '已过期',
  status_disabled: '停用',
  published_yes: '已发布',
  published_no: '草稿',
  card_member_no: '会员编号',
  card_expires: '有效至',
  card_no_link: '你的账户未链接会员记录（请联系管理员）。',
  join_open_wa: '用 WhatsApp 登记',
  join_name_ph: '姓名',
  join_company_ph: '公司',
  join_submit: '用 WhatsApp 送出',
  join_name_required: '请输入姓名',
  join_wa_unavailable: 'WhatsApp 登记暂时未能使用',
  join_wa_prefill: '登记\n姓名：{{name}}\n公司：{{company}}',
  token_working: '登录中…',
  token_invalid: '链接不正确或已过期，请重新登记。',
  legal_updated: '最后更新：2026-10-05',
  privacy_title: '隐私政策',
  privacy_intro: '香港智慧餐饮协会（HKSCA）会员系统（hksca.pages.dev）收集与使用你个人资料的方式如下。使用本系统或以 WhatsApp 登记，即代表你同意本政策。',
  privacy_collect_h: '我们收集什么',
  privacy_collect: '你的姓名／公司名、电话（WhatsApp）号码、电邮、会籍种类与到期日，以及你登记时提供的其他资料。',
  privacy_use_h: '如何使用',
  privacy_use: '只用于处理会籍、发出与展示会员卡、发送会籍及活动通知，以及协会与你联络。',
  privacy_share_h: '会否交予第三方',
  privacy_share: '不会出售或出租你的资料。只在提供服务必需时（例如云端主机、WhatsApp 讯息传送）交由服务商处理，并受合约约束。',
  privacy_retention_h: '保存多久',
  privacy_retention: '保存至会籍结束后一段合理时间，或你要求删除为止（法律要求保留者除外）。',
  privacy_rights_h: '你的权利',
  privacy_rights: '你可以要求查阅、更正或删除你的个人资料，详见「资料删除指示」。',
  privacy_contact_h: '联络我们',
  privacy_contact: '电邮 simon@coeldery85.org 查询或提出要求。',
  deletion_title: '资料删除指示',
  deletion_intro: '你可以随时要求删除 HKSCA 会员系统内你的个人资料。',
  deletion_how_h: '如何提出',
  deletion_step_1: '用你登记的 WhatsApp 号码或电邮，发讯息／电邮给下方联络方式。',
  deletion_step_2: '写明「要求删除会员资料」，并提供你的会员编号或登记电话。',
  deletion_step_3: '我们会在 30 日内确认并删除，然后回复你。',
  deletion_scope_h: '会删除什么',
  deletion_scope: '会员记录、会籍、会员卡与登录账户；依法须保留的交易记录除外。',
  deletion_contact: 'WhatsApp／电邮：simon@coeldery85.org（或用你登记的 WhatsApp 发讯息去协会号码）。',
  terms_title: '服务条款',
  terms_intro: '这些条款管你使用香港智慧餐饮协会（HKSCA）会员系统（hksca.pages.dev）。使用本系统或以 WhatsApp 登记，即代表你接受本条款。',
  terms_accept_h: '接受条款',
  terms_accept: '一经使用本系统或完成登记，你同意遵守本条款与相关政策（包括隐私政策）。如你不同意，请停止使用。',
  terms_account_h: '会籍与账户',
  terms_account: '会籍由协会按实际情况审批；你须提供真实、准确的资料，并保持登录凭证安全。你须为自己账户下的活动负责。',
  terms_conduct_h: '使用守则',
  terms_conduct: '不得滥用系统：包括但不限于未经授权存取、干扰服务、上传违法或侵权内容、冒充他人或作欺诈用途。',
  terms_content_h: '内容与知识产权',
  terms_content: '系统内的商标、标志与内容属协会或相关伙伴所有。优惠／资讯由合作伙伴提供，实际供应以商户条款为准。',
  terms_liability_h: '责任限制',
  terms_liability: '系统按「现状」提供；我们力求准确但不保证无误。对因使用或无法使用系统而引致的损失，我们在法律允许范围内不负责任。',
  terms_changes_h: '条款更新',
  terms_changes: '我们可能不时更新本条款，更新后会于本页公布并更新「最后更新」日期。继续使用即代表接受新版本。',
  terms_contact_h: '联络我们',
  terms_contact: '如对本条款有疑问，请电邮 simon@coeldery85.org。',
  pw_title: '更改密码',
  pw_none_hint: '你未设置密码。设置后，下次可用电话号码＋密码登录（不用再开 WhatsApp）。',
  pw_current: '目前密码',
  pw_save: '保存密码',
  pw_saved: '密码已更新 ✅',
  pw_failed: '更新失败，请再试。',
  ann_all: '全会',
  ann_unread: '未读',
  ann_empty: '暂无公告',
  task_new: '新增待办事项',
  task_field_title: '待办事项',
  task_field_notes: '备注',
  task_field_owner: '负责人',
  task_field_due: '截止日期',
  task_field_priority: '优先次序',
  task_field_committee: '所属委员会',
  task_priority_1: '高',
  task_priority_2: '中',
  task_priority_3: '低',
  task_status_todo: '待处理',
  task_status_doing: '进行中',
  task_status_done: '已完成',
  task_status_cancelled: '已取消',
  task_unassigned: '未指派',
  task_overdue: '已逾期',
  task_empty: '暂无待办事项',
  task_mine: '指派给我的',
  task_filter_all: '全部',
  task_scope_all: '全部委员会',
  task_summary: '共 {{total}} 项，已完成 {{done}} 项',
  task_need_title: '请输入待办事项。',
  task_need_committee: '请选择所属委员会。',
  task_failed: '操作失败，请重试。',
  mtg_new: '安排会议',
  mtg_field_title: '会议名称',
  mtg_field_location: '地点',
  mtg_field_starts: '会议时间',
  mtg_field_ends: '结束时间',
  mtg_field_committee: '所属委员会',
  mtg_field_minutes: '会议记录',
  mtg_status_scheduled: '待举行',
  mtg_status_done: '已完成',
  mtg_status_cancelled: '已取消',
  mtg_empty: '暂无会议',
  mtg_scope_all: '全部委员会',
  mtg_filter_all: '全部',
  mtg_count: '{{n}} 项议程',
  mtg_back: '返回会议列表',
  mtg_agenda: '议程',
  mtg_agenda_add: '新增议程项',
  mtg_agenda_title: '议程项',
  mtg_agenda_notes: '备注',
  mtg_agenda_decision: '议决',
  mtg_agenda_empty: '暂无议程',
  mtg_action_from_agenda: '生成待办',
  mtg_attendance: '出席',
  mtg_attendance_seed: '由委员名册载入',
  mtg_attendance_rate: '出席 {{present}}／{{roster}}（{{rate}}%）',
  mtg_attendance_empty: '尚未载入出席名册',
  mtg_att_invited: '未回复',
  mtg_att_present: '出席',
  mtg_att_absent: '缺席',
  mtg_att_excused: '请假',
  mtg_actions: '行动项',
  mtg_actions_hint: '行动项会即时写入「待办」，并链接回本会议。',
  mtg_action_add: '新增行动项',
  mtg_action_empty: '暂无行动项',
  mtg_minutes_save: '保存记录',
  mtg_saved: '已保存 ✅',
  mtg_failed: '操作失败，请重试。',
  mtg_need_title: '请输入会议名称。',
  mtg_need_time: '请选择会议时间。',
  ctab_discussions: '讨论',
  disc_new: '开新议题',
  disc_field_title: '议题标题',
  disc_field_body: '议题说明',
  disc_open: '进行中',
  disc_closed: '已关闭',
  disc_empty: '暂无议题',
  disc_scope_all: '全部委员会',
  disc_filter_all: '全部',
  disc_posts: '{{n}} 条留言',
  disc_last: '最后活动',
  disc_back: '返回讨论列表',
  disc_post_ph: '输入留言…',
  disc_post_send: '留言',
  disc_post_empty: '暂无留言，欢迎展开讨论。',
  disc_close: '关闭议题',
  disc_reopen: '重新开启',
  disc_closed_hint: '此议题已关闭，不再接受留言。',
  disc_delete_topic: '删除此议题',
  disc_need_title: '请输入议题标题。',
  disc_failed: '操作失败，请重试。',
  polls: '表决',
  poll_new: '提出议案',
  poll_field_title: '议案标题',
  poll_field_body: '议案说明',
  poll_field_closes: '截止时间',
  poll_status_open: '投票中',
  poll_status_closed: '已结束',
  poll_empty: '暂无议案',
  poll_scope_all: '全部委员会',
  poll_filter_all: '全部',
  poll_cast: '已投票 {{n}} 人',
  poll_my: '您投了：{{option}}',
  poll_not_voted: '您尚未投票',
  poll_back: '返回表决列表',
  poll_closed_hint: '此议案已结束，不再接受投票。',
  poll_closes_at: '截止',
  poll_voters: '投票记录',
  poll_no_voters: '暂无投票记录',
  poll_need_title: '请输入议案标题。',
  poll_failed: '操作失败，请重试。',
  poll_close: '结束投票',
  poll_reopen: '重新开放',
  poll_delete: '删除此议案',
  poll_tied: '（并列）',
  opt_agree: '同意',
  opt_disagree: '反对',
  opt_abstain: '弃权',
  rsvp_title: '邀请回复',
  rsvp_greeting: '{{name}}，您好',
  rsvp_event: '活动',
  rsvp_date: '日期',
  rsvp_venue: '地点',
  rsvp_guests: '同行人数',
  rsvp_accept: '我会出席',
  rsvp_decline: '未能出席',
  rsvp_sent_accept: '已记录：您将出席，感谢回复。',
  rsvp_sent_decline: '已记录：您未能出席，感谢回复。',
  rsvp_accepted: '已接受',
  rsvp_declined: '已婉拒',
  rsvp_invalid: '此链接无效或已失效，请联系协会秘书处。',
  rsvp_failed: '操作失败，请重试。',
  ltr_title: '活动信件',
  ltr_intro: '建立信件模板、导入名单、分批寄出邀请，并追踪回复（每位收件人一条专属 RSVP 链接）。',
  ltr_tab_templates: '信件模板',
  ltr_tab_groups: '收件名单',
  ltr_tab_sends: '寄送批次',
  ltr_purpose_invite: '邀请函',
  ltr_purpose_sponsor: '赞助邀约',
  ltr_purpose_thanks: '答谢信',
  ltr_purpose_other: '其他',
  ltr_tpl_name: '模板名称',
  ltr_ai_brief: '（可选）补充要求，例如：强调粤港澳大湾区交流',
  ltr_ai_draft: 'AI 草稿',
  ltr_ai_working: 'AI 生成中…',
  ltr_ai_local: '已生成草稿（Workers AI，数据未离开 Cloudflare）—— 请复核后再保存。',
  ltr_ai_third_party: '⚠️ 已生成草稿（经第三方 AI）—— 请复核后再保存。',
  ltr_tpl_subject: '主旨',
  ltr_tpl_body: '内文',
  ltr_tpl_fields: '可用合并栏位：{{fields}}',
  ltr_tpl_new: '新增模板',
  ltr_saved: '已保存 ✅',
  ltr_failed: '操作失败，请重试。',
  ltr_grp_count: '{{n}} 位收件人',
  ltr_grp_name: '名单名称',
  ltr_grp_text: '贴上收件人（每行一位：email, 姓名, 公司, 职称, 电话）',
  ltr_grp_new: '新增名单',
  ltr_grp_parsed: '已加入 {{n}} 位（略过 {{skipped}} 行）',
  ltr_status_draft: '草稿',
  ltr_status_sending: '寄送中',
  ltr_status_done: '已完成',
  ltr_status_cancelled: '已取消',
  ltr_status_pending: '待寄',
  ltr_status_sent: '已寄出',
  ltr_status_failed: '寄送失败',
  ltr_status_simulated: '模拟寄送',
  ltr_send_pick_tpl: '选模板…',
  ltr_send_pick_grp: '选名单…',
  ltr_send_new: '建立寄送批次',
  ltr_need_pick: '请先选择模板与名单。',
  ltr_send_missing: '注意：模板使用 {{fields}}，但收件人未提供 —— 请补齐资料或修改模板。',
  ltr_send_created: '已建立 {{n}} 封（逐人个人化，预览 ＝ 实际寄出）',
  ltr_send_result: '本批处理 {{n}} 封，尚余 {{remaining}} 封。',
  ltr_rsvp_note: '每封信会附上该收件人的专属 RSVP 链接；回复会即时显示于上方统计。',
  ltr_back: '返回信件列表',
  ltr_stat_pending: '待寄',
  ltr_stat_sent: '已寄',
  ltr_stat_simulated: '模拟',
  ltr_stat_failed: '失败',
  ltr_stat_accepted: '已接受',
  ltr_stat_declined: '已婉拒',
  ltr_email_unconfigured: '未设置寄送凭证（EMAIL_API_KEY／EMAIL_FROM）—— 现时只可使用「模拟寄送」。',
  ltr_send_now: '寄出（每批 {{n}} 封）',
  ltr_send_dry: '模拟寄送（不会真正寄出）',
  ltr_export: '导出 CSV',
  ltr_rotate: '重新产生 RSVP 链接',
  ltr_rotate_note: '已重新产生链接（旧链接即时失效）；如未寄出，请把新链接贴到要用的地方。',
  ltr_copy: '复制',
  ltr_copied: '已复制',
  ltr_recipients: '收件人',
  ltr_tab_events: '活动',
  ltr_evt_name: '活动名称',
  ltr_evt_venue: '地点',
  ltr_evt_new: '新增活动',
  ltr_evt_note: '活动资料会喂入 {{event_name}}／{{event_date}}／{{event_venue}} 三个合并栏位。',
  ltr_evt_closed: '已结束',
  ltr_send_pick_evt: '（可选）链接活动…',
  admin_letters: '活动信件',
  admin_sponsors: '赞助',
  sp_intro: '管理赞助方案（可用 AI 草拟）、追踪 pipeline 进度与金额，并落实每个赞助商的权益清单。',
  sp_pipeline: '进度概览',
  sp_total_pledged: '承诺总额',
  sp_total_paid: '已收总额',
  sp_outstanding: '未收',
  sp_stage_lead: '初步接触',
  sp_stage_contacted: '已联络',
  sp_stage_pitched: '已递交方案',
  sp_stage_pledged: '口头承诺',
  sp_stage_confirmed: '已确认',
  sp_stage_paid: '已收款',
  sp_stage_declined: '已婉拒',
  sp_tiers: '赞助方案',
  sp_tier_new: '新增方案',
  sp_tier_code: '代号（可选，例如 diamond）',
  sp_name_hk: '名称（繁中）',
  sp_name_cn: '名称（简体）',
  sp_name_en: '名称（英文）',
  sp_tier_amount: '建议金额（港元）',
  sp_tier_benefits: '权益（每行一项）',
  sp_benefit_n: '{{n}} 项权益',
  sp_benefit_unit: '项权益',
  sp_ai_tiers: 'AI 草拟方案',
  sp_ai_review: 'AI 草稿 —— 请复核后保存',
  sp_ai_save_all: '全部保存',
  sp_ai_working: 'AI 生成中…',
  sp_ai_local: '已生成草稿（Workers AI，数据未离开 Cloudflare）—— 请复核。',
  sp_ai_third_party: '⚠️ 已生成草稿（经第三方 AI）—— 请复核。',
  sp_ai_saved: '已保存 {{n}} 个方案',
  sp_sponsors: '赞助商',
  sp_sponsor_new: '新增赞助商',
  sp_company: '企业名称',
  sp_contact_name: '联络人',
  sp_contact_email: '联络电邮',
  sp_contact_phone: '联络电话',
  sp_tier: '方案',
  sp_pledge: '承诺金额',
  sp_paid: '已收金额',
  sp_stage: '阶段',
  sp_amounts: '金额与跟进',
  sp_owner_code: '跟进人代号（不使用真名）',
  sp_next_action: '下次动作',
  sp_note: '备注',
  sp_benefits: '权益落实',
  sp_benefits_hint: '可一键由方案自动生成，之后逐项打勾。',
  sp_seed: '由方案生成权益（{{n}} 项）',
  sp_seeded: '已生成 {{n}} 项权益',
  sp_add_benefit: '新增权益项',
  sp_back: '返回赞助列表',
  sp_delete: '删除此赞助商',
  sp_failed: '操作失败，请重试。',
  sp_saved: '已保存 ✅',
  sp_need_tier: '请填齐三语方案名称。',
  sp_need_company: '请输入企业名称。',
  sp_ai_suggest: 'AI 建议下一步',
  sp_ai_suggesting: 'AI 分析中…',
  sp_ai_apply: '套用建议',
  sp_suggest: 'AI 建议：{{stage}}',
  sp_suggest_reason: '理由：{{reason}}',
  admin_seating: '座位',
  admin_checkin: '报到',
  seat_intro: '管理桌位与嘉宾、一键自动分桌（可先预览），活动当天在「报到」页输入码即可确认。',
  seat_assign: '自动分桌',
  seat_preview_btn: '预览分桌（不会改动）',
  seat_commit_btn: '确认分桌',
  seat_clear: '清空分桌',
  seat_rule_note: '规则：VIP 优先并优先安排到 VIP 区 → 同行人数多者先安排 → 每桌不超过容量；坐不下的会列出姓名，不会静默消失。每一项都会记录理由。',
  seat_result: '已分桌 {{assigned}} 位，未分桌 {{unassigned}} 位',
  seat_occupancy: '已坐 {{seats}}／{{cap}}',
  seat_free: '剩 {{n}} 位',
  seat_totals: '合计：已分桌 {{seats}} 位／总容量 {{cap}} 位／未分桌 {{un}} 位',
  seat_tables: '桌位',
  seat_capacity_n: '容量 {{n}} 人',
  seat_table_label: '桌号（例如：1 号桌）',
  seat_capacity: '容量',
  seat_zone_vip: 'VIP 区',
  seat_zone_main: '主区',
  seat_zone_other: '其他',
  seat_table_new: '新增桌位',
  seat_guests: '嘉宾',
  seat_checked: '已报到 {{n}}',
  seat_party_n: '{{n}} 人',
  seat_no_table: '（未分桌）',
  seat_party: '同行人数',
  seat_guest_new: '新增嘉宾',
  seat_paste: '贴上嘉宾（每行一位：姓名, 公司, 联络, 同行人数, VIP）',
  seat_import: '导入',
  seat_parsed: '已导入 {{n}} 位（略过 {{skipped}} 行）',
  seat_committed: '已确认分桌（{{n}} 位）',
  seat_preview: '以上是预览 —— 点击「确认分桌」才会写入。',
  seat_saved: '已保存 ✅',
  seat_failed: '操作失败，请重试。',
  ci_intro: '输入或扫描嘉宾的报到码（QR 或手动；不分大小写）即显示姓名与桌号。',
  ci_placeholder: '报到码（例如：G1A2B3C4）',
  ci_submit: '报到',
  ci_notfound: '找不到此报到码，请核对或从下方名单选择。',
  ci_failed: '操作失败，请重试。',
  ci_done_at: '已于 {{at}} 报到',
  ci_checked: '已报到 {{n}}／{{total}} 位',
  ci_pending: '未报到',
  ci_check: '报到',
  admin_budget: '对数',
  bg_intro: '活动预算 vs 实际支出，加上赞助已收款，即时显示盈余／赤字。',
  bg_summary: '对数汇总',
  bg_items: '预算项目',
  bg_category: '分类',
  bg_budget: '预算',
  bg_actual: '实际',
  bg_variance: '差额',
  bg_expense: '支出',
  bg_income: '收入',
  bg_other: '其他',
  bg_cat_expense: '支出',
  bg_cat_income: '收入',
  bg_cat_other: '其他',
  bg_sponsor_paid: '赞助已收款（自动计入收入）',
  bg_net_budget: '预算净额',
  bg_net_actual: '实际净额',
  bg_surplus: '盈余',
  bg_deficit: '赤字',
  bg_item: '项目（例如：场地租金）',
  bg_new: '新增项目',
  bg_saved: '已保存 ✅',
  bg_failed: '操作失败，请重试。',
  bg_hint: '差额 ＝ 实际 − 预算（正数代表超支）。赞助已收款会自动计入收入，无需手动录入。',
  admin_report: '活动报告',
  rp_ai: 'AI 总结',
  rp_print: '打印／另存 PDF',
  rp_no_event: '（未指定活动）',
  rp_no_date: '日期未定',
  rp_ai_narrative: 'AI 总结',
  rp_scale: '规模与出席',
  rp_guests: '嘉宾 {{n}} 位（{{seats}} 席）',
  rp_checked: '已报到 {{n}} 位',
  rp_unassigned: '未分桌 {{n}} 位',
  rp_tables: '桌位 {{n}} 张：已坐 {{seats}}／{{cap}} 席',
  rp_sponsors: '赞助成果',
  rp_sponsor_totals: '{{n}} 间企业：承诺 {{pledged}}／已收 {{paid}}／未收 {{outstanding}}',
  rp_failed: '加载失败，请重试。',
  sp_thank_letter: '准备答谢信',
  sp_thank_ok: '已加入「答谢信名单」—— 去「活动信件」选答谢模板即可寄出。',
  committee_title: '理事会',
  ctab_home: '首页',
  ctab_announcements: '公告',
  ctab_meetings: '会议',
  ctab_tasks: '待办',
  committee_need_login: '请先登录（用你的会员电话号码）。',
  committee_my: '我的委员会',
  committee_none: '你未属任何委员会 —— 请联系协会。',
  committee_invitations: '待回覆邀请',
  committee_accept: '接受',
  committee_decline: '婉拒',
  committee_joined: '已加入 ✅',
  committee_declined: '已婉拒',
  committee_soon_h: '即将推出',
  committee_soon_b: '这个功能会在 Phase 2 逐个补上（公告／会议／待办）。',
  admin_committees: '委员会',
  committee_new: '新增委员会',
  committee_kind: '种类',
  kind_board: '理事会',
  kind_functional: '功能委员会',
  kind_working: '工作委员会／小组',
  committee_code: '代号',
  committee_name_hk: '名称（繁中）',
  committee_name_cn: '名称（简体）',
  committee_name_en: '名称（英文）',
  committee_sort: '排序',
  committee_count: '委员',
  committee_members: '成员',
  committee_pick_member: '选择会员…',
  committee_invite: '邀请加入',
  committee_status_active: '现任',
  committee_status_invited: '待回覆',
  committee_invited_ok: '已发出邀请',
  invite_member: '邀请',
  invite_working: '生成中…',
  invite_need_email: '请先填写会员 email，才可以发邀请。',
  invite_failed: '邀请失败，请再试。',
  invite_link_title: '邀请链接（7 日内有效）',
  invite_copy: '复制链接',
  invite_copied: '已复制',
  invite_link_note: '只可发给该会员本人；他点进去设置密码，账户即刻启用。',
  invite_bound: '已链接账户',
  footer_privacy: '隐私政策',
  footer_deletion: '资料删除指示',
  footer_terms: '服务条款',
};
